"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Suspension;

var _immutable = require("immutable");

var _ActionTypes = require("../actions/ActionTypes");

var _Constants = require("../Constants");

var _SuspensionAppealStates = _interopRequireDefault(require("../enums/SuspensionAppealStates"));

var defaultState = (0, _immutable.Map)({
  suspended: false,
  canAppeal: false,
  appealState: _SuspensionAppealStates.default.UNINITIATED,
  fetchStatus: _Constants.RequestStatus.UNINITIALIZED
});

function Suspension() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type;

  switch (type) {
    case _ActionTypes.FETCH_SUSPENSION_STATE_ATTEMPTED:
      return state.set('fetchStatus', _Constants.RequestStatus.PENDING);

    case _ActionTypes.FETCH_SUSPENSION_STATE_SUCCEEDED:
      return action.data.set('fetchStatus', _Constants.RequestStatus.SUCCEEDED);

    case _ActionTypes.FETCH_SUSPENSION_STATE_FAILED:
      return state.set('fetchStatus', _Constants.RequestStatus.SUCCEEDED);

    default:
      return state;
  }
}

module.exports = exports.default;